export const getShankWidth = (filters) => {
  if (filters.shank_shape === 'straight') {
    if (filters.shank_straight_width === 'custom') {
      return 'shank_straight_custom_width'
    } else {
      return 'shank_straight_width'
    }
  } else if (filters.shank_shape === 'taper_in_towards_centre' || filters.shank_shape === 'taper_out_towards_centre') {
    return 'shank_tapered_width'
  }
}

export const validateRingCommonFields = (filters) => {
  let shankWidth = getShankWidth(filters)
  let shankThickness = filters.vertical_shank_thickness && filters.vertical_shank_thickness === 'custom' ? 'custom_vertical_shank_thickness' : 'vertical_shank_thickness'
  const fieldNames = [
    'ring_size',
    'shank_type',
    'shank_shape',
    shankWidth,
    shankThickness
  ]

  const fieldErrorMsgMapping = {
    'vertical_shank_thickness': 'Ring Weight (Vertical Shank Thickness)',
    'custom_vertical_shank_thickness': 'Custom Shank Thickness',
    'shank_type': 'Shank Type',
    'shank_shape': 'Shank Shape',
    'shank_straight_width': 'Total Shank Width (Straight Shank)',
    'shank_straight_custom_width': 'Total Shank Width (Straight Shank) - Custom',
    'shank_tapered_width': 'Total Shank Width (Tapered Shank)'
  }

  let missingFields = fieldNames.filter((e) => { return filters[e] === null })
  return missingFields.map((field) => {
    return fieldErrorMsgMapping[field]
  })
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/ring-common-fields/index.js